module.exports = __webpack_public_path__ + "static/media/precios_paneles.f35ff5a7.png";